import React, { useState } from "react";
import logo from "../images/EnvironmentalLabsLogoHorizontal.png";
import profile from "../images/profile.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faChevronDown,
  faSignOutAlt,
  faChartLine,
  faUserCircle,
  faWater,
  faGlassWater,
  faCodeCompare,
  faHome,
  faBars,
  faTimes,
  faChevronRight,faBottleWater,faFileInvoice
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function MobileHeader({
  logout,
  isMultiClient,
  clientType,
  clearClient,
  accountNumber,
}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigationItems = [
    {
      label: "Dashboard",
      route: "/dashboard",
      icon: faChartLine,
    },
    {
          label: "Invoices",
          route: "/invoices",
          icon: faFileInvoice,
        },
        {
          label: "Bottle Orders",
          route: "/bottle-orders",
          icon: faBottleWater,
        },
    {
      label: "Client Profile",
      route: "/client",
      icon: faUserCircle,
    },
    ...(clientType?.toLowerCase().includes("etk")
      ? [
          {
            label: "Water Profile Comparison",
            route: "/water-profile-comparison",
            icon: faCodeCompare,
          },
          {
            label: "Water Profiles",
            route: "/water-profiles",
            icon: faGlassWater,
          },
        ]
      : []),
  ];

  const handleNavClick = (callback) => {
    setIsSidebarOpen(false);
    if (callback) callback();
  };

  return (
    <>
      {/* Top Navigation Bar */}
      <nav className="mobile-navbar" role="navigation" aria-label="main navigation">
        <div className="mobile-navbar-container">
          {/* Menu Toggle */}
          <button
            className="menu-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            aria-label="Toggle menu"
          >
            <FontAwesomeIcon 
              icon={isSidebarOpen ? faTimes : faBars} 
              className="menu-icon"
            />
          </button>

          {/* Logo */}
          <div className="mobile-brand">
            <Link to="/" className="brand-link">
              <img src={logo} alt="ELI Logo" className="brand-logo" />
            </Link>
          </div>

          {/* User Avatar */}
          <div className="mobile-user-avatar">
            <img src={profile} alt="Client" className="client-logo" />
          </div>
        </div>
      </nav>

      {/* Sidebar Overlay */}
      <div 
        className={`sidebar-overlay ${isSidebarOpen ? "active" : ""}`}
        onClick={() => setIsSidebarOpen(false)}
      ></div>

      {/* Sidebar */}
      <div className={`mobile-sidebar ${isSidebarOpen ? "active" : ""}`}>
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <div className="user-section">
            <div className="user-avatar-large">
              <img src={profile} alt="Client" className="client-logo" />
            </div>
            <div className="user-info">
              <div className="user-title">Client Portal</div>
              {accountNumber && (
                <div className="user-account">Account: {accountNumber}</div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Menu */}
        <div className="sidebar-menu">
          {isMultiClient && (
            <>
              <button 
                className="sidebar-item home-item" 
                onClick={() => handleNavClick(clearClient)}
              >
                <div className="item-icon">
                  <FontAwesomeIcon icon={faHome} />
                </div>
                <div className="item-content">
                  <span className="item-text">Home</span>
                  <span className="item-subtitle">Return to main dashboard</span>
                </div>
                <FontAwesomeIcon icon={faChevronRight} className="item-arrow" />
              </button>
              <div className="menu-divider"></div>
            </>
          )}

          {navigationItems.map((item) => (
            <Link
              key={item.route}
              to={item.route}
              className="sidebar-item"
              onClick={() => handleNavClick()}
            >
              <div className="item-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>
              <div className="item-content">
                <span className="item-text">{item.label}</span>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="item-arrow" />
            </Link>
          ))}

          <div className="menu-divider"></div>

          {/* Settings Section */}
          <Link
            to="/client"
            className="sidebar-item"
            onClick={() => handleNavClick()}
          >
            <div className="item-icon">
              <FontAwesomeIcon icon={faUserCircle} />
            </div>
            <div className="item-content">
              <span className="item-text">Profile Settings</span>
              <span className="item-subtitle">Manage your account</span>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className="item-arrow" />
          </Link>
        </div>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          <button className="logout-button" onClick={() => handleNavClick(logout)}>
            <FontAwesomeIcon icon={faSignOutAlt} className="logout-icon" />
            <span>Sign Out</span>
          </button>
        </div>
      </div>

      <style jsx>{`
        .mobile-navbar {
          background: linear-gradient(135deg, #ffffff 0%, #f8fafb 100%);
          border-bottom: 1px solid #e1e8ed;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
          position: sticky;
          top: 0;
          z-index: 1000;
          backdrop-filter: blur(10px);
        }

        .mobile-navbar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1rem;
          min-height: 70px;
        }

        .menu-toggle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border: none;
          background: transparent;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #4a5568;
        }

        .menu-toggle:hover {
          background: rgba(58, 138, 95, 0.1);
          color: var(--eli-primary);
        }

        .menu-icon {
          font-size: 1.25rem;
          transition: transform 0.3s ease;
        }

        .mobile-brand {
          flex: 1;
          display: flex;
          justify-content: center;
        }

        .brand-link {
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        .brand-logo {
          height: 40px;
          width: auto;
          transition: transform 0.2s ease;
        }

        .mobile-user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid var(--eli-primary);
          background: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .client-logo {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          padding: 3px;
        }

        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          backdrop-filter: blur(2px);
        }

        .sidebar-overlay.active {
          opacity: 1;
          visibility: visible;
        }

        .mobile-sidebar {
          position: fixed;
          top: 0;
          left: 0;
          height: 100vh;
          width: 320px;
          max-width: 85vw;
          background: white;
          z-index: 1001;
          transform: translateX(-100%);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          flex-direction: column;
          box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
        }

        .mobile-sidebar.active {
          transform: translateX(0);
        }

        .sidebar-header {
          padding: 2rem 1.5rem 1.5rem 1.5rem;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-bottom: 1px solid #f1f5f9;
        }

        .user-section {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .user-avatar-large {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 3px solid var(--eli-primary);
          background: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          flex-shrink: 0;
        }

        .user-info {
          flex: 1;
          min-width: 0;
        }

        .user-title {
          font-weight: 600;
          color: #2d3748;
          font-size: 1.1rem;
          margin-bottom: 0.25rem;
        }

        .user-account {
          font-size: 0.85rem;
          color: #718096;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .sidebar-menu {
          flex: 1;
          padding: 1rem 0;
          overflow-y: auto;
        }

        .sidebar-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem 1.5rem;
          color: #4a5568;
          text-decoration: none;
          background: none;
          border: none;
          width: 100%;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: left;
        }

        .sidebar-item:hover {
          background: #f8fafc;
          color: var(--eli-primary);
        }

        .sidebar-item.home-item {
          color: var(--eli-primary);
        }

        .sidebar-item.home-item:hover {
          background: rgba(58, 138, 95, 0.08);
        }

        .item-icon {
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f7fafc;
          border-radius: 12px;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .sidebar-item:hover .item-icon {
          background: var(--eli-primary-soft);
          color: var(--eli-primary);
        }

        .sidebar-item.home-item .item-icon {
          background: rgba(58, 138, 95, 0.1);
          color: var(--eli-primary);
        }

        .item-icon svg {
          font-size: 1.1rem;
        }

        .item-content {
          flex: 1;
          min-width: 0;
        }

        .item-text {
          display: block;
          font-weight: 500;
          font-size: 1rem;
          margin-bottom: 0.125rem;
        }

        .item-subtitle {
          display: block;
          font-size: 0.8rem;
          color: #718096;
          opacity: 0.8;
        }

        .item-arrow {
          color: #cbd5e0;
          font-size: 0.9rem;
          transition: all 0.2s ease;
        }

        .sidebar-item:hover .item-arrow {
          color: var(--eli-primary);
          transform: translateX(2px);
        }

        .menu-divider {
          height: 1px;
          background: #f1f5f9;
          margin: 0.5rem 0;
        }

        .sidebar-footer {
          padding: 1.5rem;
          border-top: 1px solid #f1f5f9;
          background: #f8fafc;
        }

        .logout-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          width: 100%;
          padding: 1rem;
          background: #fed7d7;
          color: #e53e3e;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .logout-button:hover {
          background: #feb2b2;
          color: #c53030;
          transform: translateY(-1px);
        }

        .logout-icon {
          font-size: 1.1rem;
        }

        /* Animations */
        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 375px) {
          .mobile-sidebar {
            width: 100vw;
            max-width: 100vw;
          }
        }

        @media (max-height: 600px) {
          .sidebar-header {
            padding: 1rem 1.5rem;
          }
          
          .user-avatar-large {
            width: 50px;
            height: 50px;
          }
          
          .sidebar-item {
            padding: 0.75rem 1.5rem;
          }
        }
      `}</style>
    </>
  );
}